import React, { useEffect, useState } from "react";
import '../Styles/Sapakim/SViewCustomerProfile.css';
import { useNavigate, useParams } from "react-router-dom";
import { doc, getDoc, collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import AdminHead from "./AdminHead";

function SViewCustomerProfile() {
  const nav = useNavigate();
  const { UID, CDID } = useParams();

  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const customerRef = doc(db, "Customers", CDID);
        const docSnap = await getDoc(customerRef);
        if (docSnap.exists()) {
          setCustomer(docSnap.data());
        } else {
          console.warn("לקוח לא נמצא");
        }
      } catch (err) {
        console.error("שגיאה בטעינת פרטי לקוח:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [CDID]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const ordersQuery = query(
          collection(db, "Orders"),
          where("SapakId", "==", UID),
          where("CustomerID", "==", CDID)
        );

        const snapshot = await getDocs(ordersQuery);
        const fetchedOrders = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setOrders(fetchedOrders);
      } catch (error) {
        console.error("שגיאה בקבלת ההזמנות:", error);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchOrders();
  }, [UID, CDID]);

  const cancelOrder = async (orderId) => {
    try {
      const orderRef = doc(db, "Orders", orderId);
      await updateDoc(orderRef, { Status: "מבוטלת" });

      setOrders(prevOrders =>
        prevOrders.map(order =>
          order.id === orderId ? { ...order, Status: "מבוטלת" } : order
        )
      );
    } catch (err) {
      console.error("שגיאה בביטול הזמנה:", err);
    }
  };

  if (loading) return <Loading />;
  if (!customer) return <p style={{ textAlign: "center" }}>הלקוח לא נמצא.</p>;

  return (
    <React.Fragment>
      <AdminHead />
      <div className="Customer-Info" dir="rtl">
        <h2>פרטי לקוח</h2>
        <p><strong>שם:</strong> {customer.Name || "לא צויין"}</p>
        <p><strong>טלפון:</strong> {customer.PhoneNumber || "לא צויין"}</p>
        <p><strong>כתובת:</strong> {customer.Location || "לא צויין"}</p>

        {showMore && (
          <>
            <p><strong>טלפון נוסף:</strong> {customer.ExtraPhone || "לא צויין"}</p>
            <p><strong>אימייל:</strong> {customer.Email || "לא צויין"}</p>
            <p><strong>תעודת זהות:</strong> {customer.IdNumber || "לא צויין"}</p>
            <p><strong>מיקוד:</strong> {customer.PostalCode || "לא צויין"}</p>
          </>
        )}

        <button className="toggle-btn" onClick={() => setShowMore(!showMore)}>
          {showMore ? "הצג פחות" : "הצג עוד"}
        </button>
      </div>

      <div className="Customer-Orders" dir="rtl">
        <h3>הזמנות של לקוח זה</h3>
        <button onClick={() => nav(`/AdminHome/${UID}/ViewCustomers/${CDID}/CreateNewOrder`)}>
          צור הזמנה חדשה
        </button>

        {ordersLoading ? (
          <p>טוען הזמנות...</p>
        ) : orders.length === 0 ? (
          <p>אין הזמנות עבור לקוח זה.</p>
        ) : (
          orders.map(order => (
            <div className="order-card" key={order.id}>
              <p><strong>מזהה הזמנה:</strong> {order.orderNumber}</p>
              <p><strong>תאריך:</strong> {order.createdAt ? new Date(order.createdAt.seconds * 1000).toLocaleDateString() : "לא צויין"}</p>
              <p><strong>סטטוס:</strong> {order.Status || "לא צויין"}</p>
              <button onClick={() => {nav(`/AdminHome/${UID}/ViewOrder/${CDID}/${order.id}`)}}>הצג הזמנה</button>
              {order.Status === "ממתין לאישור" && (
                <button
                  style={{ background: 'red' }}
                  onClick={() => cancelOrder(order.id)}
                >
                  ביטול הזמנה
                </button>
              )}
            </div>
          ))
        )}
      </div>
    </React.Fragment>
  );
}

export default SViewCustomerProfile;
